/* ShivaRam · Tu Tarot Personal · lógica del juego.
   - Sin dependencias externas, sin almacenamiento (no usa cookies, localStorage ni envíos).
   - Las cartas se barajan con crypto.getRandomValues (Fisher–Yates).
   - Los productos se piden a la propia tienda (Section Rendering API), solo los necesarios. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tarot-app]');
  if (!root) return;
  var section = root.closest('.tarot');
  var LANG = (section.getAttribute('data-lang') || 'es').toLowerCase();
  var ROOT = section.getAttribute('data-root') || '/';
  var T = Object.assign({}, window.TAROT_TEXTOS.es, window.TAROT_TEXTOS[LANG] || {});
  var CARDS = (window.TAROT_CARTAS && (window.TAROT_CARTAS[LANG] || window.TAROT_CARTAS.es)) || [];
  var FUENTES = window.TAROT_FUENTES || {};
  var ASOC = window.TAROT_ASOC || {};
  var NAVY = '#172B4D', GOLD = '#C6A15B', CREAM = '#FBF8F2';
  var ROMAN = ['0','I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII','XIII','XIV','XV','XVI','XVII','XVIII','XIX','XX','XXI'];
  var RANK = T.rank || ['','As','II','III','IV','V','VI','VII','VIII','IX','X','Sota','Caballo','Reina','Rey'];
  if (T.fuentes) for (var fk in T.fuentes) if (FUENTES[fk] && T.fuentes[fk]) FUENTES[fk].f = T.fuentes[fk];

  // si la clienta o el cliente ha iniciado sesión, Shopify rellena data-nombre con su nombre de pila (solo se usa en esta pantalla)
  var state = { nombre: (section.getAttribute('data-nombre') || '').trim().slice(0, 30), fecha: null, modo: 1, cartas: [], reveladas: 0 };
  var ADV = T.adv || window.TAROT_TEXTOS.es.adv;

  /* ---------- utilidades ---------- */
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function rnd(n) { // entero aleatorio uniforme en [0, n)
    if (window.crypto && crypto.getRandomValues) {
      var max = Math.floor(4294967296 / n) * n, x = new Uint32Array(1);
      do { crypto.getRandomValues(x); } while (x[0] >= max);
      return x[0] % n;
    }
    return Math.floor(Math.random() * n);
  }
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = rnd(i + 1); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function aviso() { var a = section.querySelector('[data-tarot-aviso]'); if (a) a.textContent = T.aviso; }
  function go(node, paso) {
    root.innerHTML = '';
    if (paso) node.insertBefore(pasos(paso), node.firstChild);
    root.appendChild(node);
    var top = section.getBoundingClientRect().top + window.pageYOffset - 20; if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  // indicador de progreso: 1 Tus datos · 2 Tus cartas · 3 Tu lectura
  function pasos(actual) {
    var ol = el('ol', { class: 'tarot__steps', 'aria-label': T.pasosAria || '' });
    [T.paso1, T.paso2, T.paso3].forEach(function (t, i) {
      var li = el('li', { class: 'tarot__step' + (i + 1 < actual ? ' is-done' : i + 1 === actual ? ' is-current' : '') }, [el('span', { class: 'tarot__step-n', text: String(i + 1) }), el('span', { class: 'tarot__step-t', text: t })]);
      if (i + 1 === actual) li.setAttribute('aria-current', 'step');
      ol.appendChild(li);
    });
    return ol;
  }

  /* ---------- ilustraciones originales (SVG) ---------- */
  function sym(name) {
    var g = GOLD;
    var P = {
      sol: '<circle cx="100" cy="150" r="26" fill="none" stroke="' + g + '" stroke-width="4"/>' + rays(100, 150, 34, 50, 12),
      luna: '<path d="M118 112a40 40 0 1 0 0 76a32 32 0 1 1 0-76z" fill="' + g + '"/>',
      estrella: star(100, 150, 46, 16, 8),
      lemniscata: '<path d="M60 150c0-18 22-18 40 0s40 18 40 0-22-18-40 0-40 18-40 0z" fill="none" stroke="' + g + '" stroke-width="5"/>',
      espiral: '<path d="M100 150m0 0a6 6 0 1 1 6 6a14 14 0 1 1-20-14a24 24 0 1 1 30 34a34 34 0 1 1-44-46" fill="none" stroke="' + g + '" stroke-width="4" stroke-linecap="round"/>',
      columnas: '<rect x="56" y="100" width="14" height="100" fill="' + g + '"/><rect x="130" y="100" width="14" height="100" fill="none" stroke="' + g + '" stroke-width="3"/><path d="M112 128a20 20 0 1 0 0 30a16 16 0 1 1 0-30z" fill="' + g + '"/>',
      venus: '<circle cx="100" cy="132" r="26" fill="none" stroke="' + g + '" stroke-width="5"/><path d="M100 158v46M82 184h36" stroke="' + g + '" stroke-width="5"/>',
      trono: '<rect x="66" y="112" width="68" height="76" fill="none" stroke="' + g + '" stroke-width="5"/><path d="M66 112l34-22 34 22" fill="none" stroke="' + g + '" stroke-width="5"/>',
      llaves: '<g stroke="' + g + '" stroke-width="5" fill="none"><circle cx="82" cy="118" r="12"/><circle cx="118" cy="118" r="12"/><path d="M88 128l34 62M112 128l-34 62M116 178l10-4M84 178l-10-4"/></g>',
      corazones: heart(84, 146, 0.8) + heart(116, 146, 0.8),
      carro: '<g stroke="' + g + '" stroke-width="5" fill="none"><path d="M64 140h72l-10 30H74z"/><circle cx="78" cy="182" r="12"/><circle cx="122" cy="182" r="12"/><path d="M100 140v-36l18 12-18 12"/></g>',
      leon: '<circle cx="100" cy="150" r="22" fill="' + g + '"/>' + rays(100, 150, 26, 40, 16) + '<path d="M60 108c10-14 70-14 80 0" fill="none" stroke="' + g + '" stroke-width="4"/>',
      farol: '<g stroke="' + g + '" stroke-width="4" fill="none"><path d="M84 120h32l-4 54H88z"/><path d="M92 120l8-14 8 14M100 104v-10"/></g><path d="M100 136c8 10 6 22 0 26-6-4-8-16 0-26z" fill="' + g + '"/>',
      rueda: wheel(),
      balanza: '<g stroke="' + g + '" stroke-width="4" fill="none"><path d="M100 100v100M70 200h60M60 124h80"/><path d="M60 124l-16 34h32zM140 124l-16 34h32z"/></g>',
      triangulo: '<path d="M64 112h72l-36 74z" fill="none" stroke="' + g + '" stroke-width="5"/><circle cx="100" cy="132" r="8" fill="' + g + '"/>',
      amanecer: '<path d="M56 176h88M66 176a34 34 0 0 1 68 0" fill="none" stroke="' + g + '" stroke-width="5"/>' + rays(100, 176, 42, 56, 9, true),
      copas2: '<g fill="none" stroke="' + g + '" stroke-width="4"><path d="M58 116h34c0 22-8 34-17 34s-17-12-17-34zM108 136h34c0 22-8 34-17 34s-17-12-17-34z"/></g><path d="M84 146q16 10 32 6" fill="none" stroke="' + g + '" stroke-width="3" stroke-dasharray="4 4"/>',
      cadenas: '<g fill="none" stroke="' + g + '" stroke-width="5"><ellipse cx="82" cy="128" rx="14" ry="22"/><ellipse cx="100" cy="150" rx="14" ry="22"/><ellipse cx="118" cy="172" rx="14" ry="22"/></g>',
      torre: '<g stroke="' + g + '" stroke-width="4" fill="none"><path d="M80 204V122h40v82M74 122h52l-8-14H82z"/></g><path d="M126 92l-18 30h12l-14 28 26-36h-12l12-22z" fill="' + g + '"/>',
      trompeta: '<path d="M60 170l60-30v60zM120 140h20v60h-20" fill="none" stroke="' + g + '" stroke-width="4"/>' + rays(150, 170, 10, 22, 7, true),
      corona: '<ellipse cx="100" cy="150" rx="40" ry="56" fill="none" stroke="' + g + '" stroke-width="5"/><ellipse cx="100" cy="150" rx="30" ry="46" fill="none" stroke="' + g + '" stroke-width="2" stroke-dasharray="3 5"/>' + star(100, 150, 14, 6, 4)
    };
    return P[name] || '';
  }
  function rays(cx, cy, r1, r2, n, half) {
    var s = '', tot = half ? n : n;
    for (var i = 0; i < tot; i++) {
      var a = half ? Math.PI + (i + 0.5) * Math.PI / n : i * 2 * Math.PI / n;
      s += '<line x1="' + (cx + r1 * Math.cos(a)).toFixed(1) + '" y1="' + (cy + r1 * Math.sin(a)).toFixed(1) + '" x2="' + (cx + r2 * Math.cos(a)).toFixed(1) + '" y2="' + (cy + r2 * Math.sin(a)).toFixed(1) + '" stroke="' + GOLD + '" stroke-width="3" stroke-linecap="round"/>';
    }
    return s;
  }
  function star(cx, cy, R, r, n) {
    var pts = [];
    for (var i = 0; i < n * 2; i++) { var a = -Math.PI / 2 + i * Math.PI / n, rr = i % 2 ? r : R; pts.push((cx + rr * Math.cos(a)).toFixed(1) + ',' + (cy + rr * Math.sin(a)).toFixed(1)); }
    return '<polygon points="' + pts.join(' ') + '" fill="' + GOLD + '"/>';
  }
  function heart(cx, cy, s) {
    return '<path transform="translate(' + cx + ' ' + cy + ') scale(' + s + ')" d="M0 18C-24 2-24-20-8-20c5 0 8 4 8 8 0-4 3-8 8-8 16 0 16 22-8 38z" fill="' + GOLD + '"/>';
  }
  function wheel() {
    var s = '<circle cx="100" cy="150" r="44" fill="none" stroke="' + GOLD + '" stroke-width="5"/><circle cx="100" cy="150" r="8" fill="' + GOLD + '"/>';
    for (var i = 0; i < 8; i++) { var a = i * Math.PI / 4; s += '<line x1="100" y1="150" x2="' + (100 + 44 * Math.cos(a)).toFixed(1) + '" y2="' + (150 + 44 * Math.sin(a)).toFixed(1) + '" stroke="' + GOLD + '" stroke-width="3"/>'; }
    return s;
  }
  function suitIcon(palo, x, y, s) {
    var g = GOLD, t = 'translate(' + x + ' ' + y + ') scale(' + s + ')';
    if (palo === 'copas') return '<path transform="' + t + '" d="M-12-14h24c0 14-5 22-12 22s-12-8-12-22zM0 8v8M-7 16h14" fill="none" stroke="' + g + '" stroke-width="2.6"/>';
    if (palo === 'bastos') return '<g transform="' + t + '" stroke="' + g + '" stroke-width="2.6" fill="none"><path d="M-6 16L6-16"/><path d="M2-6l6-2M-2 4l-6 1"/></g>';
    if (palo === 'espadas') return '<g transform="' + t + '" stroke="' + g + '" stroke-width="2.6" fill="none"><path d="M0-17v26M-8 9h16M0 9v8"/></g>';
    return '<g transform="' + t + '"><circle r="13" fill="none" stroke="' + g + '" stroke-width="2.6"/>' + star(0, 0, 8, 3.2, 5).replace('fill="' + GOLD + '"', 'fill="' + g + '"') + '</g>';
  }
  var MAJOR_SYM = ['espiral','lemniscata','columnas','venus','trono','llaves','corazones','carro','leon','farol','rueda','balanza','triangulo','amanecer','copas2','cadenas','torre','estrella','luna','sol','trompeta','corona'];
  function pips(palo, n) {
    var L = {1:[[100,150]],2:[[100,110],[100,190]],3:[[100,100],[100,150],[100,200]],4:[[72,112],[128,112],[72,188],[128,188]],
      5:[[72,108],[128,108],[100,150],[72,192],[128,192]],6:[[72,104],[128,104],[72,150],[128,150],[72,196],[128,196]],
      7:[[72,100],[128,100],[100,126],[72,152],[128,152],[72,200],[128,200]],8:[[72,98],[128,98],[72,132],[128,132],[72,168],[128,168],[72,202],[128,202]],
      9:[[72,98],[128,98],[72,132],[128,132],[100,150],[72,168],[128,168],[72,202],[128,202]],10:[[72,96],[128,96],[100,114],[72,132],[128,132],[72,168],[128,168],[100,186],[72,204],[128,204]]}[n];
    var sc = n === 1 ? 2.6 : n <= 4 ? 1.35 : 1.05;
    return L.map(function (p) { return suitIcon(palo, p[0], p[1], sc); }).join('');
  }
  function court(palo, r) {
    var crown = r === 14 ? '<path d="M78 108l8 14 14-16 14 16 8-14v22H78z" fill="' + GOLD + '"/>' : r === 13 ? '<path d="M82 112l9 10 9-14 9 14 9-10v16H82z" fill="none" stroke="' + GOLD + '" stroke-width="3"/>' : r === 12 ? '<path d="M76 128c8-18 40-18 48 0" fill="none" stroke="' + GOLD + '" stroke-width="3"/><path d="M96 110l4-8 4 8" fill="none" stroke="' + GOLD + '" stroke-width="3"/>' : '<circle cx="100" cy="116" r="8" fill="none" stroke="' + GOLD + '" stroke-width="3"/>';
    return crown + suitIcon(palo, 100, 168, 2.4);
  }
  function cardSVG(c) {
    var top, mid;
    if (c.t === 'mayor') { top = ROMAN[c.num]; mid = sym(MAJOR_SYM[c.num]); }
    else if (c.num <= 10) { top = RANK[c.num]; mid = pips(c.t, c.num); }
    else { top = RANK[c.num]; mid = court(c.t, c.num); }
    var name = c.n.length > 20 ? c.n.replace(' de la ', ' de la ') : c.n;
    return '<svg viewBox="0 0 200 320" role="img" aria-label="' + c.n.replace(/"/g, '') + '" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="200" height="320" rx="14" fill="' + NAVY + '"/>' +
      '<rect x="9" y="9" width="182" height="302" rx="9" fill="none" stroke="' + GOLD + '" stroke-width="1.6"/>' +
      '<rect x="15" y="15" width="170" height="290" rx="6" fill="none" stroke="' + GOLD + '" stroke-opacity=".45" stroke-width=".8"/>' +
      '<text x="100" y="46" text-anchor="middle" font-family="Georgia,serif" font-size="18" letter-spacing="2" fill="' + GOLD + '">' + top + '</text>' +
      '<g>' + mid + '</g>' +
      '<line x1="44" y1="250" x2="156" y2="250" stroke="' + GOLD + '" stroke-opacity=".6"/>' +
      '<text x="100" y="278" text-anchor="middle" font-family="Georgia,serif" font-size="' + (name.length > 18 ? 12.5 : 15) + '" fill="' + CREAM + '">' + escapeXml(name) + '</text>' +
      '</svg>';
  }
  function backSVG() {
    return '<svg viewBox="0 0 200 320" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="200" height="320" rx="14" fill="' + NAVY + '"/>' +
      '<rect x="9" y="9" width="182" height="302" rx="9" fill="none" stroke="' + GOLD + '" stroke-width="1.6"/>' +
      '<circle cx="100" cy="160" r="62" fill="none" stroke="' + GOLD + '" stroke-opacity=".7"/>' +
      '<circle cx="100" cy="160" r="48" fill="none" stroke="' + GOLD + '" stroke-opacity=".5" stroke-dasharray="2 5"/>' +
      star(100, 160, 40, 14, 8) + '<circle cx="100" cy="160" r="9" fill="' + NAVY + '"/>' +
      '<text x="100" y="286" text-anchor="middle" font-family="Georgia,serif" font-size="13" letter-spacing="3" fill="' + GOLD + '">SHIVARAM</text></svg>';
  }
  function escapeXml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- formulario ---------- */
  function formulario() {
    var hoy = new Date().toISOString().slice(0, 10);
    var err = el('p', { class: 'tarot__error', role: 'alert' });
    var inNombre = el('input', { type: 'text', id: 'tarot-nombre', maxlength: '30', autocomplete: 'off', placeholder: T.nombrePh, value: state.nombre });
    var inFecha = el('input', { type: 'date', id: 'tarot-fecha', max: hoy, min: '1900-01-01', autocomplete: 'off', value: state.fecha ? state.fecha.iso : '' });
    function opt(v, tit, desc) {
      var id = 'tarot-modo-' + v;
      var r = el('input', { type: 'radio', name: 'tarot-modo', id: id, value: String(v) });
      if (state.modo === v) r.checked = true;
      return el('label', { class: 'tarot__opt', for: id }, [r, el('span', { class: 'tarot__opt-box' }, [el('strong', { text: tit }), el('small', { text: desc })])]);
    }
    var form = el('form', { class: 'tarot__form', novalidate: 'novalidate', onsubmit: function (e) {
      e.preventDefault(); err.textContent = '';
      var nombre = inNombre.value.trim().replace(/\s+/g, ' ');
      if (!/^[0-9A-Za-zÀ-ÖØ-öø-ÿ'’ .-]{2,30}$/.test(nombre)) { err.textContent = T.errNombre; inNombre.focus(); return; }
      var v = inFecha.value, m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
      if (!m) { err.textContent = T.errFecha; inFecha.focus(); return; }
      var y = +m[1], mo = +m[2], d = +m[3], dt = new Date(y, mo - 1, d);
      if (y < 1900 || dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) { err.textContent = T.errFecha; inFecha.focus(); return; }
      if (dt > new Date()) { err.textContent = T.errFechaFutura; inFecha.focus(); return; }
      var modo = +(form.querySelector('input[name="tarot-modo"]:checked') || {}).value || 1;
      state.nombre = nombre; state.fecha = { iso: v, d: d, m: mo, y: y }; state.modo = modo === 3 ? 3 : 1;
      tirar();
    } }, [
      el('div', { class: 'tarot__field' }, [el('label', { for: 'tarot-nombre', text: T.nombre }), inNombre]),
      el('div', { class: 'tarot__field' }, [el('label', { for: 'tarot-fecha', text: T.fecha }), inFecha]),
      el('fieldset', { class: 'tarot__field tarot__modos' }, [el('legend', { text: T.tirada }), opt(1, T.una, T.unaDesc), opt(3, T.tres, T.tresDesc)]),
      el('p', { class: 'tarot__privacy', text: T.privacidad }),
      err,
      el('button', { type: 'submit', class: 'tarot__btn tarot__btn--primary tarot__btn--wide', text: T.descubrir })
    ]);
    go(el('div', { class: 'tarot__panel' }, [form]), 1);
  }

  /* ---------- tirada ---------- */
  function tirar() {
    state.cartas = shuffle(CARDS).slice(0, state.modo);
    state.reveladas = 0;
    var pos = state.modo === 3 ? [T.pasado, T.presente, T.futuro] : [T.mensaje];
    var mesa = el('div', { class: 'tarot__mesa tarot__mesa--' + state.modo });
    var btnInterp = el('button', { type: 'button', class: 'tarot__btn tarot__btn--primary', disabled: 'disabled', text: T.verInterpretacion, onclick: interpretacion });
    state.cartas.forEach(function (c, i) {
      var flip = el('div', { class: 'tarot__flip' }, [
        el('div', { class: 'tarot__face tarot__face--back', html: backSVG() }),
        el('div', { class: 'tarot__face tarot__face--front', html: cardSVG(c) })
      ]);
      var btn = el('button', { type: 'button', class: 'tarot__btn tarot__btn--ghost', text: T.revelar });
      var nombre = el('p', { class: 'tarot__cardname', text: '' });
      btn.addEventListener('click', function () {
        flip.classList.add('is-revealed'); btn.disabled = true; btn.hidden = true; nombre.textContent = c.n;
        state.reveladas++; if (state.reveladas === state.cartas.length) { btnInterp.disabled = false; btnInterp.focus({ preventScroll: true }); }
      });
      mesa.appendChild(el('div', { class: 'tarot__slot' }, [el('p', { class: 'tarot__pos', text: pos[i] }), el('div', { class: 'tarot__card', style: 'animation-delay:' + (i * 120) + 'ms' }, [flip]), nombre, btn]));
    });
    go(el('div', { class: 'tarot__panel' }, [
      el('h2', { class: 'tarot__h2', text: fmt(T.saludo, { nombre: state.nombre }) }),
      el('p', { class: 'tarot__lead', text: state.modo === 3 ? T.intro3 : T.intro1 }),
      mesa,
      el('div', { class: 'tarot__actions' }, [btnInterp])
    ]), 2);
  }

  function cartaNacimiento() {
    var f = state.fecha, s = String(f.d) + String(f.m) + String(f.y), n = 0;
    for (var i = 0; i < s.length; i++) n += +s[i];
    while (n > 22) n = String(n).split('').reduce(function (a, b) { return a + +b; }, 0);
    if (n === 22) n = 0;
    return CARDS[n];
  }

  function bloque(tit, txt, cls) { return el('div', { class: 'tarot__b ' + (cls || '') }, [el('h4', { text: tit }), el('p', { text: txt })]); }

  function seccion(cls, tit, hijos) { return el('section', { class: 'tarot__sec ' + (cls || '') }, [el('h3', { class: 'tarot__h3', text: tit })].concat(hijos)); }
  function claves(c) { return c.k.split(',').slice(0, 2).join(',').trim(); }

  /* ---------- consejos personalizados: se eligen a partir de las cartas que han salido ---------- */
  function consejos() {
    var cs = state.cartas, G = ADV.G, cnt = {};
    cs.forEach(function (c) { cnt[c.t] = (cnt[c.t] || 0) + 1; });
    var iPres = cs.length === 3 ? 1 : 0, pc = cs[iPres], dom = pc.t;
    Object.keys(cnt).forEach(function (k) { if (cnt[k] > cnt[dom]) dom = k; });
    var g = G[dom] || G.mayor;
    // 1) un consejo práctico de cada carta (texto propio de la carta) + 2) consejos generales de su ámbito
    var tips = cs.map(function (c) { return { b: fmt(ADV.segun, { carta: c.n }), t: c.c }; });
    if (cs.length === 3) tips.push({ b: ADV.general, t: g.t[pc.num % 2] });
    else { tips.push({ b: ADV.general, t: g.t[0] }); tips.push({ b: ADV.general, t: g.t[1] }); }
    // preguntas: la de cada carta (2–3 en total)
    var preg = cs.map(function (c) { return c.q; });
    if (cs.length === 1) preg.push(g.q);
    // pequeño paso: según la carta del presente (o la única carta)
    var gp = G[pc.t] || G.mayor;
    var rel = [];
    if (cs.length === 3) {
      var may = cnt.mayor || 0;
      if (may === 3) rel.push(ADV.relMay3);
      else if (may === 2) rel.push(ADV.relMay2);
      else {
        var rep = Object.keys(cnt).filter(function (k) { return k !== 'mayor' && cnt[k] >= 2; })[0];
        if (rep) rel.push(fmt(ADV.relPalo, { palo: ADV.palos[rep], area: G[rep].a }));
        else rel.push(fmt(ADV.relMixto, { lista: Object.keys(cnt).map(function (k) { return ADV.palos[k]; }).join(', ') }));
      }
      rel.push(fmt(ADV.relCamino, { c1: cs[0].n, k1: claves(cs[0]), c2: cs[1].n, k2: claves(cs[1]), c3: cs[2].n, k3: claves(cs[2]) }));
    }
    return { tips: tips, preg: preg, paso: gp.s[pc.num % 2], pasoNota: fmt(ADV.pasoNota, { carta: pc.n }), rel: rel };
  }

  function interpretacion() {
    var nombres = state.cartas.map(function (c) { return c.n; });
    var resumen = state.modo === 3 ? fmt(T.resumen3, { nombre: state.nombre, c1: nombres[0], c2: nombres[1], c3: nombres[2] }) : fmt(T.resumen1, { nombre: state.nombre, c1: nombres[0] });
    var temas = fmt(ADV.temas, { temas: state.cartas.map(function (c) { return c.k; }).join(' · ') });
    var pos = state.modo === 3 ? ['pa', 'pr', 'fu'] : ['pr'];
    var posT = state.modo === 3 ? [T.pasado, T.presente, T.futuro] : [T.mensaje];
    var lista = el('div', { class: 'tarot__lecturas' });
    state.cartas.forEach(function (c, i) {
      lista.appendChild(el('article', { class: 'tarot__lectura' }, [
        el('div', { class: 'tarot__lectura-img', html: cardSVG(c) }),
        el('div', { class: 'tarot__lectura-txt' }, [
          el('p', { class: 'tarot__pos', text: posT[i] }),
          el('h3', { text: c.n }),
          el('p', { class: 'tarot__kw', text: T.palabras + ': ' + c.k }),
          bloque(T.significado, c.s),
          bloque(T.enTirada, c[pos[i]], 'tarot__b--hl'),
          bloque(T.positivo, c.p, 'tarot__b--pr'),
          bloque(T.retos, c.r, 'tarot__b--re'),
          bloque(T.conclusion, c.f)
        ])
      ]));
    });
    var nac = cartaNacimiento(), adv = consejos();
    state.lectura = { resumen: resumen, temas: temas, pos: pos, posT: posT, nac: nac, adv: adv };
    var prodWrap = el('div', { class: 'tarot__productos', id: 'tarot-productos' });
    var estadoPdf = el('p', { class: 'tarot__pdf-estado', role: 'status', 'aria-live': 'polite' });
    function btnPdf(cls) { return el('button', { type: 'button', class: 'tarot__btn ' + cls, 'data-tarot-pdf': '', html: ICONO_PDF + '<span>' + T.pdfBtn + '</span>', onclick: function () { descargarPDF(estadoPdf); } }); }
    var interp = seccion('tarot__sec--interp', ADV.secInterp, [lista]);
    if (adv.rel.length) interp.appendChild(el('aside', { class: 'tarot__rel' }, [el('h4', { text: ADV.relTit })].concat(adv.rel.map(function (t) { return el('p', { text: t }); }))));
    interp.appendChild(el('aside', { class: 'tarot__nac' }, [el('h4', { text: T.nacimiento + ': ' + nac.n }), el('p', { text: fmt(T.nacimientoTxt, { carta: nac.n, claves: nac.k }) })]));
    go(el('div', { class: 'tarot__panel' }, [
      el('h2', { class: 'tarot__h2', text: fmt(T.saludo, { nombre: state.nombre }) }),
      seccion('tarot__sec--resumen', ADV.secResumen, [el('p', { class: 'tarot__lead', text: resumen }), el('p', { class: 'tarot__temas', text: temas })]),
      el('div', { class: 'tarot__resultbar' }, [
        el('div', { class: 'tarot__resultbar-txt' }, [el('strong', { text: T.pdfBarTit }), el('span', { text: T.pdfBarTxt })]),
        el('div', { class: 'tarot__resultbar-btns' }, [btnPdf('tarot__btn--gold')])
      ]),
      estadoPdf,
      interp,
      seccion('tarot__sec--consejos', ADV.secConsejos, [
        el('p', { class: 'tarot__sec-intro', text: ADV.consejosIntro }),
        el('ul', { class: 'tarot__tips' }, adv.tips.map(function (x) { return el('li', {}, [el('strong', { text: x.b }), el('span', { text: x.t })]); }))
      ]),
      seccion('tarot__sec--preguntas', ADV.secPreguntas, [el('ul', { class: 'tarot__preguntas' }, adv.preg.map(function (q) { return el('li', { text: q }); }))]),
      seccion('tarot__sec--paso', ADV.secPaso, [el('p', { class: 'tarot__paso', text: adv.paso }), el('p', { class: 'tarot__paso-nota', text: adv.pasoNota })]),
      el('p', { class: 'tarot__note tarot__note--adv', text: ADV.avisoConsejos }),
      prodWrap,
      el('div', { class: 'tarot__actions tarot__actions--end' }, [
        btnPdf('tarot__btn--primary'),
        el('button', { type: 'button', class: 'tarot__btn tarot__btn--ghost', text: T.compartir, onclick: compartir }),
        el('button', { type: 'button', class: 'tarot__btn tarot__btn--ghost', text: T.otra, onclick: tirar })
      ]),
      el('p', { class: 'tarot__toast', role: 'status', 'aria-live': 'polite' })
    ]), 3);
    productos(prodWrap);
  }

  /* ---------- descargar la lectura en PDF (se genera en el dispositivo) ---------- */
  var ICONO_PDF = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 3v12m0 0l-5-5m5 5l5-5M5 19h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var generando = false;
  function descargarPDF(estado) {
    if (generando) return;
    var btns = [].slice.call(root.querySelectorAll('[data-tarot-pdf]'));
    function fin(msg, url) {
      generando = false;
      btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      estado.innerHTML = '';
      estado.appendChild(document.createTextNode(msg));
      if (url) { estado.appendChild(document.createTextNode(' ')); estado.appendChild(el('a', { href: url, target: '_blank', rel: 'noopener', text: T.pdfAbrir })); }
    }
    if (!window.ShivaPDF) { fin(T.pdfError); return; }
    generando = true;
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    estado.textContent = T.pdfPreparando;
    construirPDF().then(function (d) {
      var url = d.guardar(ShivaPDF.nombreArchivo(T.pdfArchivo));
      fin(T.pdfListo, url);
    }).catch(function () { fin(T.pdfError); });
  }
  function construirPDF() {
    var L = state.lectura, cartas = state.cartas;
    var tituloPag = (section.querySelector('.tarot__title') || {}).textContent || 'Tu Tarot Personal';
    var d = ShivaPDF.doc({
      titulo: tituloPag.trim(),
      subtitulo: fmt(T.pdfPara, { nombre: state.nombre }) + ' · ' + (state.modo === 3 ? T.tres + ' (' + T.tresDesc + ')' : T.una + ' (' + T.unaDesc + ')'),
      fecha: fmt(T.pdfFecha, { fecha: ShivaPDF.fechaHoy(LANG) }),
      pie: 'ShivaRam · ' + location.hostname,
      pagina: T.pdfPagina
    });
    return Promise.all(cartas.map(function (c) { return ShivaPDF.svgAJpeg(cardSVG(c), 420); })).then(function (imgs) {
      var A = L.adv;
      d.h3(fmt(T.saludo, { nombre: state.nombre }), { size: 18 });
      d.seccion(ADV.secResumen, null, { conSiguiente: 60 });
      d.p(L.resumen, { after: 6 });
      d.p(L.temas, { f: 'TI', color: ShivaPDF.C.muted, after: 10 });
      // la tirada completa, como en la mesa
      var w = cartas.length === 3 ? 118 : 150, gap = 34, h = w * 320 / 200;
      var total = cartas.length * w + (cartas.length - 1) * gap, x0 = (ShivaPDF.PW - total) / 2;
      d.asegurar(h + 70);
      var y0 = d.y + 4;
      cartas.forEach(function (c, i) {
        var x = x0 + i * (w + gap);
        d.txt(L.posT[i].toUpperCase(), x + w / 2, y0 + 8, 'HB', 7.6, ShivaPDF.C.goldDark, 1.2, 'center');
        d.imagen(imgs[i], x, y0 + 16, w, h);
        d.txt(c.n, x + w / 2, y0 + 16 + h + 16, 'T', 11.5, ShivaPDF.C.navy, 0, 'center');
      });
      d.y = y0 + h + 44;
      d.separador();
      // interpretación de cada carta
      cartas.forEach(function (c, i) {
        d.seccion(c.n, L.posT[i], { conSiguiente: 140 });
        d.p(T.palabras + ': ' + c.k, { f: 'TI', size: 11, color: ShivaPDF.C.muted, after: 8 });
        d.bloque(T.significado, c.s);
        d.bloque(T.enTirada, c[L.pos[i]], { destacado: true });
        d.bloque(T.positivo, c.p);
        d.bloque(T.retos, c.r);
        d.bloque(T.conclusion, c.f);
      });
      if (A.rel.length) {
        d.seccion(ADV.relTit, null, { conSiguiente: 80 });
        A.rel.forEach(function (t) { d.p(t, { after: 6 }); });
      }
      d.seccion(T.nacimiento + ': ' + L.nac.n, null, { conSiguiente: 80 });
      d.p(fmt(T.nacimientoTxt, { carta: L.nac.n, claves: L.nac.k }), { after: 8 });
      // consejos, preguntas y pequeño paso
      d.seccion(ADV.secConsejos, null, { dorada: true, conSiguiente: 90 });
      d.p(ADV.consejosIntro, { color: ShivaPDF.C.muted, after: 6 });
      d.vinetas(A.tips.map(function (x) { return { b: x.b + ':', t: x.t }; }));
      d.seccion(ADV.secPreguntas, null, { dorada: true, conSiguiente: 70 });
      d.vinetas(A.preg);
      d.seccion(ADV.secPaso, null, { dorada: true, conSiguiente: 60 });
      d.p(A.paso, { f: 'TI', size: 13, color: ShivaPDF.C.navy, after: 4 });
      d.p(A.pasoNota, { size: 9.5, color: ShivaPDF.C.muted, after: 10 });
      d.nota(ADV.avisoConsejos);
      d.separador();
      d.nota(T.aviso, { align: 'center' });
      d.nota(T.pdfPrivacidad, { align: 'center' });
      return d;
    });
  }

  /* ---------- productos ---------- */
  var cache = {};
  var SORTS = ['best-selling', 'created-descending', 'price-ascending', 'title-ascending', 'manual'];
  function url(u) {
    var base = ROOT === '/' ? '' : ROOT.replace(/\/$/, '');
    return base + u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=tarot-productos&sort_by=' + SORTS[rnd(SORTS.length)];
  }
  function fetchFuente(key) {
    if (cache[key]) return Promise.resolve(cache[key]);
    var f = FUENTES[key];
    if (!f) return Promise.resolve([]);
    return fetch(url(f.u), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = /<script[^>]*data-tarot-productos[^>]*>([\s\S]*?)<\/script>/.exec(html);
      if (!m) return [];
      var data = JSON.parse(m[1]);
      if (f.u.indexOf('filter.') > -1 && !data.fa) return []; // filtro aún no activo: no mostrar productos sin relación
      var items = (data.items || []).map(function (p) { p.k = key; return p; });
      cache[key] = items; return items;
    }).catch(function () { return []; });
  }
  function productos(wrap) {
    wrap.innerHTML = '';
    wrap.appendChild(el('h3', { class: 'tarot__h3', text: T.productosTit }));
    wrap.appendChild(el('p', { class: 'tarot__lead', text: T.productosIntro }));
    var grid = el('div', { class: 'tarot__grid', 'aria-busy': 'true' }, [el('p', { class: 'tarot__loading', text: T.cargando })]);
    wrap.appendChild(grid);
    // fuentes de cada carta, barajadas; intentamos hasta 6 fuentes distintas
    var keys = [];
    var por = state.cartas.map(function (c) { return shuffle(ASOC[c.id] || []); });
    for (var r = 0; keys.length < 8 && r < 6; r++) por.forEach(function (l) { if (l[r] && keys.indexOf(l[r]) < 0) keys.push(l[r]); });
    // reserva (colecciones sin filtros) por si alguna fuente filtrada no devuelve productos: así siempre hay al menos 3
    var reserva = ['velas', 'diarios', 'incienso'].filter(function (k) { return FUENTES[k] && keys.indexOf(k) < 0; });
    var objetivo = state.modo === 3 ? 5 : 4;
    Promise.all(keys.concat(reserva).map(fetchFuente)).then(function (todo) {
      var vistos = {}, elegidos = [], res = todo.slice(0, keys.length);
      // ronda: un producto por fuente, en orden, hasta el objetivo; la reserva solo se usa si no se llega a 3
      for (var ronda = 0; ronda < 3 && elegidos.length < objetivo; ronda++) {
        if (ronda === 2) { if (elegidos.length >= 3) break; res = todo.slice(keys.length); }
        res.forEach(function (items) {
          if (elegidos.length >= objetivo || !items.length) return;
          var pool = shuffle(items).filter(function (p) { return !vistos[p.u]; });
          if (pool[0]) { vistos[pool[0].u] = 1; elegidos.push(pool[0]); }
        });
      }
      grid.innerHTML = ''; grid.removeAttribute('aria-busy');
      if (!elegidos.length) { grid.appendChild(el('p', { class: 'tarot__note', text: T.sinProductos })); return; }
      elegidos.forEach(function (p) {
        var b0 = ROOT === '/' ? '' : ROOT.replace(/\/$/, ''), href = b0 && p.u.indexOf(b0 + '/') !== 0 ? b0 + p.u : p.u; // la URL de Shopify ya puede llevar el idioma
        grid.appendChild(el('article', { class: 'tarot__prod' }, [
          el('a', { class: 'tarot__prod-img', href: href }, [el('img', { src: p.i, alt: p.a, loading: 'lazy', width: '480', height: '480' })]),
          el('div', { class: 'tarot__prod-body' }, [
            el('h4', {}, [el('a', { href: href, text: p.t })]),
            el('p', { class: 'tarot__price', text: (p.v ? T.desde + ' ' : '') + p.p }),
            el('p', { class: 'tarot__why', text: (FUENTES[p.k] || {}).f || '' }),
            el('a', { class: 'tarot__btn tarot__btn--small', href: href, text: T.verProducto })
          ])
        ]));
      });
      wrap.appendChild(el('p', { class: 'tarot__note', text: T.avisoProductos }));
    });
  }

  /* ---------- compartir (sin nombre ni fecha) ---------- */
  function compartir() {
    var txt = fmt(T.compartirTxt, { cartas: state.cartas.map(function (c) { return c.n; }).join(', ') });
    var link = location.origin + location.pathname;
    var toast = root.querySelector('.tarot__toast');
    if (navigator.share) { navigator.share({ title: document.title, text: txt, url: link }).catch(function () {}); return; }
    var full = txt + ' ' + link;
    var done = function () { if (toast) { toast.textContent = T.copiado; setTimeout(function () { toast.textContent = ''; }, 4000); } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(full).then(done, function () { fallbackCopy(full); done(); });
    else { fallbackCopy(full); done(); }
  }
  function fallbackCopy(s) { var t = el('textarea', { readonly: 'readonly', style: 'position:fixed;opacity:0' }); t.value = s; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); }

  if (CARDS.length !== 78) { root.textContent = T.errDatos || 'Error'; return; }
  aviso();
  formulario();
})();
